export enum DocumentListTitles {
  DOCUMENT = 'Documents',
  PHOTOS = 'Photos',
  OPERATIONS_PHOTOS = 'Operations Photos',
  INSPECTIONS_PHOTOS = 'Inspections Photos'
}
